import { Box, Href, Icon, Text } from '@factorialco/deprecated-design-system'
import { AtsFileAttachment } from 'generated/resources/graphql'

interface Props {
  attachment: AtsFileAttachment
}

export const AttachedFile = ({ attachment }: Props) => {
  const attachmentUrl = attachment.url ? attachment.url : ''

  return (
    <Href href={attachmentUrl} target="_blank" download={attachment.filename}>
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
        gap="s16"
        borderRadius={{ all: 'abs008' }}
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: 'grey400',
          },
        }}
        paddingX="s24"
        paddingY="s16"
        background="grey000White"
        maxWidth="full"
      >
        <Text.Normal size="300" weight="medium" color="grey1000" ellipsis>
          {attachment.filename}
        </Text.Normal>
        <Box flexNoShrink>
          <Icon.Medium icon="download" color="grey1000" />
        </Box>
      </Box>
    </Href>
  )
}
